import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { remediationRegistersApi, templateApi } from '../services/api';
import { RegisterManagementPage } from './RegisterManagementPage';
import type { Template } from '../types/models';

export const RemediationRegistersPage: React.FC = () => {
  // Fetch templates dynamically from the API
  const { data: templatesData } = useQuery({
    queryKey: ['templates', 'remediation'],
    queryFn: () => templateApi.list('remediation'),
  });

  // Convert templates to dropdown options (only show active templates)
  const templates = templatesData
    ?.filter((t: Template) => t.isActive)
    .map((t: Template) => ({
      value: t.templateName,
      label: t.displayName,
    })) || [];

  // Determine default template (first active template, or fallback)
  const defaultTemplate = templates.length > 0 ? templates[0].value : 'comprehensive';

  return (
    <RegisterManagementPage
      title="Remediation Registers"
      iconClass="ri-folder-line"
      queryKey="remediationRegisters"
      api={remediationRegistersApi}
      includeDepartments
      templates={templates}
      defaultTemplate={defaultTemplate}
      listPath="/remediations"
      configPath="/remediation-config"
      applyTemplateKind="remediation"
      countField="remediationCount"
      countLabel="Remediations"
      allowForceDelete
    />
  );
};
